import { EventAvailable } from "@material-ui/icons";
import ApplicationResource from "../../utils/resources.enum";
import FormsAvailabilityCreate from "./forms-availability-create";
import FormsAvailabilityEdit from "./forms-availability-edit";
import FormsAvailabilityList from "./forms-availability-list";

export const formsAvailabilityResource = {
    name: ApplicationResource.FORMS_AVAILABILITY,
    icon: EventAvailable,
    options: { label: "Disponibilidade" },
    link: "/formsAvailability",
    tableName: 'formsAvailability',
    list: FormsAvailabilityList,
    edit: FormsAvailabilityEdit,
    create: FormsAvailabilityCreate,
    products: ['office', 'forms']
};